module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm1"
  }, [_c('strong', [_vm._v("M.J. Tjia")]), _vm._v(" is a Brisbane-based writer. Her work has been longlisted for the Crime Writers Association (UK) Debut Dagger and the Margery Allingham Short Story Competition. She was awarded a Scarlet Stiletto Award (Australia) in the historical category. She is the author of "), _c('em', [_vm._v("She Be Damned: A Heloise Chancey Mystery")]), _vm._v(" from 2017. "), _c('em', [_vm._v("A Necessary Murder: A Heloise Chancey Mystery")]), _vm._v(" is the second novel in the series.")]), _vm._v(" "), _c('p', {
    staticClass: "fmc"
  }, [_vm._v("Follow M. J. on Twitter")]), _vm._v(" "), _c('p', {
    staticClass: "fmc"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/mjtjia?lang=en",
      "target": "_blank"
    }
  }, [_vm._v("@mjtjia")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417e2834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 63
// module chunks = 0